const textProps = {
  image:
    "https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80",
  skew: {
    color: "blueGray",
  },
};
export default textProps;
